export function resolveSignModalCallbackUrl({
  callbackUrl,
  pathname,
}: {
  callbackUrl?: string;
  pathname?: string | null;
}) {
  return callbackUrl || pathname || '/';
}
